<template>
    <div>
        <div ref="LabelMakerDetailByBottleMaker" style="min-height: 400px;"></div>
    </div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";
    import moment from 'moment';

    export default {
        data () {
            return {
                chart : null,
                dummyData : [
                    {"bottle_maker":"MWD", activate:this.randomInt(100, 500), failed:this.randomInt(50, 100)},
                    {"bottle_maker":"BIL", activate:this.randomInt(100, 500), failed:this.randomInt(50, 100)},
                    {"bottle_maker":"KPID", activate:this.randomInt(100, 500), failed:this.randomInt(50, 100)},
                    {"bottle_maker":"UBS", activate:this.randomInt(100, 500), failed:this.randomInt(50, 100)},
                    {"bottle_maker": null, activate:this.randomInt(100, 500), failed:this.randomInt(50, 100)},
                ],
            }
        },
        props : ['data', 'filter'],
        mounted () {
            this.createChart();
            this.getData();
        },
        watch : {
            'data' : {
                deep : true,
                handler : 'getData'
            }
        },
        methods : {
            getData () {
                let length = this.chart.data.length;
                let filter = this.filter.filter;
                let data = JSON.parse(JSON.stringify(this.data));
                let indoMonthNames = ['Januari', 'Febuari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];

                //If no data
                if (data == null || data.length == 0) data = [{period:'No Data', activate:0, failed:0}]

                console.log(JSON.stringify(data));
                this.chart.addData(data, length);
                // this.chart.addData(this.Data, length);

                // this.chart.addData(this.dummyData && this.dummyData.length > 0 ? this.dummyData : [{period:'No Data', activated:0, deactivated:0}],length);
            },

            // getData () {
            //     let length = this.chart.data.length;

            //     this.chart.addData(this.dummyData && this.dummyData.length > 0 ? this.dummyData : [{bottle_maker:'No Data', activate:0, failed:0}],length);
            // },
            createChart () {
                /* Chart code */
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end



                this.chart = am4core.create(this.$refs.LabelMakerDetailByBottleMaker, am4charts.XYChart)

                this.chart.colors.list = [
                    am4core.color("#B1E5FD"),
                    am4core.color("#FFCDD1")
                ]

                this.chart.legend = new am4charts.Legend()
                this.chart.legend.position = 'top'
                this.chart.legend.align = 'end'
                this.chart.legend.paddingBottom = 20
                this.chart.legend.labels.template.maxWidth = 95

                let xAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
                xAxis.dataFields.category = 'bottle_maker'
                xAxis.renderer.cellStartLocation = 0.1
                xAxis.renderer.cellEndLocation = 0.9
                xAxis.renderer.grid.template.location = 0;

                let yAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                yAxis.min = 0;

                this.chart.cursor = new am4charts.XYCursor();

                this.createSeries('active', 'Success');
                this.createSeries('failed', 'Failed');

            },
            createSeries(value, name) {
                let series = this.chart.series.push(new am4charts.ColumnSeries())
                series.dataFields.valueY = value
                series.dataFields.categoryX = 'bottle_maker'
                series.name = name
                series.columns.template.tooltipText = "[#fff font-size: 15px]{name} activity in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
                series.columns.template.column.cornerRadiusTopLeft = 10;
                series.columns.template.column.cornerRadiusTopRight = 10;

                // series.events.on("hidden", arrangeColumns);
                // series.events.on("shown", arrangeColumns);

                let bullet = series.bullets.push(new am4charts.LabelBullet())
                bullet.interactionsEnabled = false
                bullet.dy = 15;
                bullet.label.text = '{valueY}'
                bullet.label.fill = am4core.color('#ffffff')

                return series;
            }
        }
    }
</script>

<style scoped>

</style>